.description {
  max-width: 384px;
}
